var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",attrs:{"id":"scheduleContainer"}},[(_vm.showToggleButton)?_c('a',{attrs:{"id":"toggleBtn","href":"#"},on:{"click":_vm.handleToggleButtonClick}},[_vm._v("Toggle")]):_vm._e(),_vm._v(" "),_c('iframe',{ref:"iframe",attrs:{"id":"openSchedulingFrame","scrolling":"no","src":_vm.iframeUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }